import {
  InitClient,
  GetByParas,
  Post,
  PostWithParas
} from "../ZeusAPIClient.js";
import { apiConfig } from "../../config.js";
import { Predicate } from "../Model/Predicate.js";

InitClient(apiConfig.clientId, apiConfig.clientSecret, apiConfig.host);

/**
 * 获取转款记录分页列表
 * @param {Object} ucode
 * @param {Object} isall
 * @param {Object} pageIndex
 * @param {Object} pageSize
 * @param {Object} name
 */
async function GetOrderPageList(ucode, isall, pageIndex, pageSize, sdate, edate, name) {
  var paras = {
    ucode: ucode,
    isall: isall,
    pageIndex: pageIndex,
    pageSize: pageSize,
    sdate: sdate,
    edate: edate,
    name: name
  };
  return await GetByParas("2fdc9187-ff02-4607-9549-8d8df2661d4b", paras);
}
//获取透支分页列表

async function GetOverDraftPageList(ucode, isall, pageIndex, pageSize, name) {
  var paras = {
    ucode: ucode,
    isall: isall,
    pageIndex: pageIndex,
    pageSize: pageSize,
    name: name
  };
  return await GetByParas("82a37125-62c8-4c51-acb3-301e8535e053", paras);
}
//获取一个透支记录根据账户Id
async function GetOverdraftByAccountID(accountId) {
  var paras = {
    userid: accountId
  };
  return await GetByParas("67f4e56e-ee7c-4c7c-8e28-9ad419277f87", paras);
}
//获取用户分页列表
async function GetUserPageList(ucode, isall, pageIndex, pageSize, name) {
  var paras = {
    ucode: ucode,
    isall: isall,
    pageIndex: pageIndex,
    pageSize: pageSize,
    name: name
  };
  return await GetByParas("0730fe05-5187-4985-bf2b-d0ea22076e41", paras);
}
//根据账户ID获取单个用户
async function GetSingleUserInfo(accountId) {
  var paras = {
    userid: accountId
  };
  return await GetByParas("45daf7bb-bc01-48c7-93af-9c9e6a184f10", paras);
}
//获取专票信息列表
async function GetSpecialTikets(accountName) {
  var paras = {
    accountname: accountName
  };
  return await GetByParas("5617c66a-32b0-4e90-a443-6d7932e4d3db", paras);
}
//更新用户信息
async function UpdateUserInfo(user) {
  var data = await Post("31a5ed8f-25bf-40c7-b6e8-7a6a6e135ca3", user);
  data = data.replace('"', "");
  if (data == "success") {
    return true;
  } else {
    return false;
  }
}
//更新专票信息
async function UpdateSpecialTikets(ticket) {
  var data = await Post("8981f603-bb8a-4f7a-a61c-91b2c6c238d9", ticket);
  data = data.replace('"', "");
  if (data == "success") {
    return true;
  } else {
    return false;
  }
}
//添加用户信息
async function AddUserInfo(ucode, user) {
  var paras = {
    ucode: ucode
  };
  var data = await PostWithParas(
    "263122b0-0ae8-46a5-b90d-5f4f9d3dd795",
    paras,
    user
  );
  data = data.replace('"', "");
  if (data == "success") {
    return true;
  } else {
    return false;
  }
}
//添加专票信息
async function AddSpecialTikets(ticket) {
  var data = await Post("059c45cb-c355-4e42-b692-4c99c7e7c0ef", ticket);
  data = data.replace('"', "");
  if (data == "success") {
    return true;
  } else {
    return false;
  }
}
//获取加款信息
function GetTransferAmountList(
  userid,
  accountName,
  accountId,
  isReturn,
  pageIndex,
  pageSize
) {
  var predicates = [];
  if (userid) predicates.push(new Predicate("InitiatorID", userid, "eq", 1));
  if (accountName)
    predicates.push(new Predicate("AcountName", accountName, "contain", 1));
  if (accountId) predicates.push(new Predicate("AcountID", accountId, "eq", 1));
  if (isReturn) predicates.push(new Predicate("IsReturn", isReturn, "eq", 1));
  var request = {};
  request.Predicates = predicates;
  request.PageIndex = pageIndex;
  request.PageSize = pageSize;
  return Post("c12ba06a-24bf-4a6b-aaef-73791d95ea45", request);
}
export {
  GetOrderPageList,
  GetOverDraftPageList,
  GetOverdraftByAccountID,
  GetUserPageList,
  GetSingleUserInfo,
  GetSpecialTikets,
  UpdateUserInfo,
  UpdateSpecialTikets,
  AddUserInfo,
  AddSpecialTikets,
  GetTransferAmountList
};
